module.exports = __webpack_public_path__ + "static/img/text.74265bf9.png";